// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"141":"component---src-pages-markdown-remark-frontmatter-slug-tsx","532":"styles"}[chunkId] + "-" + {"141":"ad0ba1135c55d817ad47","532":"f2a7299418fea3d512d0"}[chunkId] + ".js";
};